import { action } from 'satcheljs/lib/legacy';
import { openFlexPane } from 'owa-suite-header-apis';

export default action('launchGetStartedPane')(function launchGetStartedPane() {
    openFlexPane('getStartedPane');
});
